var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "store-tour" }, [
    _c("div", { staticClass: "store-tour__media" }, [
      _vm.displayTour
        ? _c("iframe", {
            staticClass: "store-tour__tour",
            staticStyle: { border: "0" },
            attrs: {
              src: "https://www.google.com/maps/embed?pb=!1m0!3m2!1sen!2sus!4v1425247323636!6m8!1m7!1sVnl8zXybIIAAAAQY_PzJDA!2m2!1d34.135358!2d-116.316515!3f199.72!4f-14.950000000000003!5f0.7820865974627469",
              frameborder: "0",
            },
          })
        : _c("img", {
            staticClass: "store-tour__image",
            attrs: { src: _vm.tourImage },
          }),
    ]),
    _c(
      "div",
      { staticClass: "store-tour__content container" },
      [
        _vm._t("default"),
        _vm.haveTourImage
          ? _c("primary-button", {
              staticClass: "store-tour__cta",
              attrs: { secondary: _vm.isSecondary, label: _vm.buttonText },
              on: { click: _vm.toggleTour },
            })
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }